(() => {

  let NBD = window.NBD || {};
  if (NBD?.loaded && !window.Shopify.designMode) return;
  NBD.loaded = true;

  const themeMoneyFormat = window.theme.shopSettings.moneyFormat || window.themeVariables.settings.moneyFormat || "{{amount}}";

  NBD.formatMoney = (cents, format = "") => {
    if (typeof cents === "string") {
      cents = cents.replace(".", "");
    }
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/, formatString = format || themeMoneyFormat;
    function defaultTo(value2, defaultValue) {
      return value2 == null || value2 !== value2 ? defaultValue : value2;
    }
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultTo(precision, 2);
      thousands = defaultTo(thousands, ",");
      decimal = defaultTo(decimal, ".");
      if (isNaN(number) || number == null) {
        return 0;
      }
      number = (number / 100).toFixed(precision);
      let parts = number.split("."), dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands), centsAmount = parts[1] ? decimal + parts[1] : "";
      return dollarsAmount + centsAmount;
    }
    let value = "";
    switch (formatString.match(placeholderRegex)[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_space_separator":
        value = formatWithDelimiters(cents, 2, " ", ".");
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_with_apostrophe_separator":
        value = formatWithDelimiters(cents, 2, "'", ".");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
      case "amount_no_decimals_with_space_separator":
        value = formatWithDelimiters(cents, 0, " ");
        break;
      case "amount_no_decimals_with_apostrophe_separator":
        value = formatWithDelimiters(cents, 0, "'");
        break;
    }
    if (formatString.indexOf("with_comma_separator") !== -1) {
      return formatString.replace(placeholderRegex, value);
    } else {
      return formatString.replace(placeholderRegex, value);
    }
  }

  NBD.shopifyImgUrl = (src, size) => {
    return src.replace(/(\.[^.]*)$/, size + '$1')
  }

  NBD.debounce = (func, timeout = 300) => {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => { func.apply(this, args); }, timeout);
    };
  }

  NBD.mutationObserver = (callback, el, config) => {
    config = config || { attributes: true, childList: true, subtree: true };
    el = el || document.body;
    const observer = new MutationObserver(callback);
    observer.observe(el, config);
    return observer;
  }

  const initOnLoad = () => {
    console.info('%cTheme customisations https://newbuild.studio', 'color: hotpink');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initOnLoad();
    });
  } else {
    initOnLoad();
  }

  NBD.onLoad = (callback) => {
    callback();
  }

  window.NBD = NBD;
  document.dispatchEvent(new Event("nbd:loaded"));

})();
